import ApplicationCost from "./ApplicationCost";
import ApplicationStatus from "./ApplicationStatus";
import { ApplicationWithId } from "../../interfaces/IApplications";
import { Assignment } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

interface ApplicationInfoProps {
  application?: ApplicationWithId;
}

export default function ApplicationInfo({ application }: ApplicationInfoProps) {
  const hasApplication = !!application;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Assignment sx={{ color: "#6366f1", fontSize: 20 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#000000" }}>
          Zgłoszenie
        </Typography>
      </Box>

      {hasApplication ? (
        <>
          <ApplicationStatus application={application!} />
          <ApplicationCost application={application!} />
        </>
      ) : (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: "0.8rem", fontStyle: "italic" }}
        >
          Brak zgłoszenia na ten turniej
        </Typography>
      )}
    </Box>
  );
}
